import { createModify } from './base';
export function create(getter, setter) {
    return {
        get: getter,
        set: setter,
        modify: createModify(getter, setter),
        compose(next) {
            // no runtime dispatch – the implementation works for both
            // lens and prism argument
            return create((s) => {
                const x = getter(s);
                return x !== undefined
                    ? next.get(x)
                    : undefined;
            }, (v, s) => {
                const x = getter(s);
                return x !== undefined
                    ? setter(next.set(v, x), s)
                    : s;
            });
        }
    };
}
//# sourceMappingURL=prism.js.map